import { cn } from "@tellescope/design-system";
import { BlockProps } from "../../../types";
import { useOrdersBlock } from "../../../hooks";
import { BlockHeader } from "../BlockHeader";
import { BlockContent } from "../BlockContent";
import { OrdersRecordsList } from "./OrdersRecordsList";
import { useTranslation } from "react-i18next";
import { BlockEmptyState } from "../BlockEmptyState";

export const OrdersBlock = ({
  onMaximize,
  alwaysShowButtons = false,
  className,
  contentClassName,
  ...rest
}: BlockProps) => {
  const { t } = useTranslation("orders");
  const {
    parsedInfo,
    enduser,
    isEditingTitle,
    setIsEditingTitle,
    newTitle,
    setNewTitle,
    editMode,
    setEditMode,
    updateInfo,
    duplicateBlock,
    deleteBlock,
    toggleExpanded,
    expanded,
    blockLayout,
    canEditTitle,
    canCreateBlock,
    canDeleteBlock,
  } = useOrdersBlock({ ...rest, onMaximize, alwaysShowButtons, className });

  return (
    <div className={cn("group", className)}>
      <BlockHeader
        editMode={editMode}
        setEditMode={setEditMode}
        isEditingTitle={isEditingTitle}
        setIsEditingTitle={setIsEditingTitle}
        newTitle={newTitle}
        setNewTitle={setNewTitle}
        canEditTitle={canEditTitle}
        parsedInfo={parsedInfo}
        updateInfo={updateInfo}
        duplicateBlock={duplicateBlock}
        deleteBlock={deleteBlock}
        canCreateBlock={canCreateBlock}
        canDeleteBlock={canDeleteBlock}
        onMaximize={onMaximize}
        alwaysShowButtons={alwaysShowButtons}
      />

      <BlockContent
        editMode={editMode}
        setEditMode={setEditMode}
        expanded={expanded}
        layout={blockLayout}
        onToggleExpanded={() => toggleExpanded()}
        className={cn("flex flex-col", contentClassName)}
      >
        {!enduser ? (
          <div className="flex flex-1 items-center justify-center">
            <BlockEmptyState>{t("Loading orders...")}</BlockEmptyState>
          </div>
        ) : (
          <OrdersRecordsList contact={enduser} />
        )}
      </BlockContent>
    </div>
  );
};
